import React from "react";
import { useNavigate } from "react-router-dom";

const GUIDE_STEPS = [
    {
        step: "1",
        title: "메인 페이지에서 프로필 수정 클릭",
        description:
            "메인 화면에서 프로필 수정 버튼을 눌러 프로필 수정 페이지로 이동합니다.",
        image: "/guide/guide_1.jpg",
        alt: "탈퇴 가이드 1번 - 메인 페이지 프로필 수정 버튼 위치",
    },
    {
        step: "2",
        title: "프로필 수정 페이지에서 아래로 스크롤",
        description:
            "프로필 수정 페이지에 진입한 뒤, 화면을 아래로 스크롤합니다.",
        image: "/guide/guide_2.jpg",
        alt: "탈퇴 가이드 2번 - 프로필 수정 페이지 스크롤 안내",
    },
    {
        step: "3",
        title: "하단 회원 탈퇴 버튼 클릭",
        description:
            "맨 아래에 표시되는 회원 탈퇴 버튼을 눌러 탈퇴를 진행합니다.",
        image: "/guide/guide_3.jpg",
        alt: "탈퇴 가이드 3번 - 하단 회원 탈퇴 버튼 위치",
    },
];

const WithdrawalGuidePage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div
            className='min-h-screen text-white'
            style={{ background: "#0E0E0F" }}
        >
            <header
                className='sticky top-0 z-10 border-b'
                style={{
                    borderColor: "rgba(213, 156, 57, 0.2)",
                    background: "rgba(14, 14, 15, 0.92)",
                    backdropFilter: "blur(8px)",
                }}
            >
                <div className='px-8 py-4 flex items-center justify-between'>
                    <div className='flex items-center gap-3'>
                        <span className='text-2xl font-bold tracking-widest landing-shimmer-text'>
                            La Poit
                        </span>
                        <h1 className='text-sm md:text-base font-semibold tracking-wide'>
                            Q&amp;A - 회원 탈퇴 가이드
                        </h1>
                    </div>
                    <button
                        onClick={() => navigate("/")}
                        className='px-4 py-1.5 text-sm font-medium border rounded-full transition-all duration-200 hover:scale-105'
                        style={{ borderColor: "#D59C39", color: "#D59C39" }}
                    >
                        랜딩으로
                    </button>
                </div>
            </header>

            <main className='max-w-5xl mx-auto px-6 py-10 md:py-14'>
                <p
                    className='mb-8 text-sm md:text-base'
                    style={{ color: "rgba(255,255,255,0.75)" }}
                >
                    아래 순서대로 진행하면 회원 탈퇴를 완료할 수 있습니다.
                </p>

                <div className='space-y-8 md:space-y-10'>
                    {GUIDE_STEPS.map((item) => (
                        <section
                            key={item.step}
                            className='rounded-2xl overflow-hidden'
                            style={{
                                background: "#161617",
                                border: "1px solid rgba(213, 156, 57, 0.2)",
                            }}
                        >
                            <div className='p-4 md:p-6'>
                                <div className='flex flex-col gap-5 md:flex-row md:items-center md:gap-8'>
                                    <div className='w-full md:w-[200px] lg:w-[240px] md:shrink-0 mx-auto'>
                                        <img
                                            src={item.image}
                                            alt={item.alt}
                                            className='w-full h-auto rounded-xl'
                                            style={{
                                                border: "1px solid rgba(255,255,255,0.08)",
                                            }}
                                        />
                                    </div>

                                    <div className='flex-1 md:self-center md:flex md:justify-center'>
                                        <div className='md:w-full md:text-center'>
                                            <p
                                                className='text-xs tracking-widest uppercase mb-1'
                                                style={{ color: "#D59C39" }}
                                            >
                                                Step {item.step}
                                            </p>
                                            <h2 className='text-base md:text-lg font-semibold whitespace-nowrap'>
                                                {item.title}
                                            </h2>
                                            <p
                                                className={`mt-2 text-sm md:text-base leading-relaxed ${
                                                    item.step === "1" ? "md:whitespace-nowrap" : ""
                                                }`}
                                                style={{
                                                    color: "rgba(255,255,255,0.75)",
                                                }}
                                            >
                                                {item.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    ))}
                </div>
            </main>
        </div>
    );
};

export default WithdrawalGuidePage;
